// extracted by mini-css-extract-plugin
export const cartItem = "cartItem-module--cartItem--2fRH6";
export const itemDetails = "cartItem-module--itemDetails--SeUOn";